import React from "react";
import axios from "~/data/http/axios";
import Button from "~/Common-Objects/UI/Forms/Button/Button";
import DataTable1 from "~/Common-Objects/Tables/DataTable1/DataTable1";
import Icon from "~/Common-Objects/UI/Icon";
import Icons from "~/Common-Objects/UI/Icons/index";
import LoadingIcons from "~/Common-Objects/LoadingIcons/loadingIcon1";
import Modal from "~/Common-Objects/Modal/index";
import Paper from "~/Common-Objects/UI/Paper/Paper";
import SnackBar from "~/Common-Objects/UI/Notifications/SnackBar/SnackBar";
import SquareChip from "~/Common-Objects/UI/Chips/SquareChip.jsx";
import TextInput from "~/Common-Objects/UI/Forms/TextInput/TextInput";
import { connect } from "react-redux";
import i18n from "~/i18n";
import copy from "copy-to-clipboard";

@connect((store) => {
  return { user: store.user, siteMaster: store.siteMaster };
})
export default class MxRecords extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: "",
      error: "",
      hasChecked: 0,
      failed: {
        spf: false,
        dkim: false,
        mx: false,
      },
    };

    this.copyClipboard = this.copyClipboard.bind(this);
    this.checkMxRecord = this.checkMxRecord.bind(this);
  }

  componentDidMount() { }

  copyClipboard(value) {
    copy(value);
    this.setState({
      alertOpen: true,
      alertMessage: i18n.t("copiedToClipBoard"),
    });
  }

  async checkMxRecord() {
    this.setState({ error: "", hasChecked: 1, failed: { spf: false, dkim: false, mx: false } });
    try {
      let result = await axios.put(
        `/accountMaster/domain/${this.props.domain.id}/authenticatemx`
      );
      if (!result.data.success) {
        let failed = { spf: false, dkim: false, mx: false };
        if (result.data.failed) failed = result.data.failed;
        return this.setState({ error: result.data.error, failed, hasChecked: 2 });
      }
      this.props.finish();
    } catch (err) {
      this.setState({ error: "MX Record was not found", hasChecked: 2 });
    }
  }

  render() {
    let spfHost = "spf.ourmailsender.com";
    if (this.props.siteMaster.spfRecordUrl)
      spfHost = this.props.siteMaster.spfRecordUrl + ".ourmailsender.com";
    return (
      <>
        <Modal
          width='90%'
          height='90%'
          noClickAway={true}
          blurBg={true}
          top={false}
          closeButton={true}
          onCloseButton={this.props.finish}
        >

          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '100%' }}>
            <div className='newUserFormOuterContentHolder'>
              <div
                style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '100%' }}
              >

                <h2 className='mar-b15 text-center'> {i18n.t("company:domains.mxRecord.setupMxRecordHeader")}</h2>
                <div className='mar-b40 text-center text-grey-800 text-md' style={{ lineHeight: "1.5" }}>
                  Create an MX record that points to our servers so your emails are marked as originating from your domain, instead of {this.props.siteMaster.siteName}.
                  {this.props.siteMaster.siteId == 1 && <a className="mar-l5" href="">Learn more</a>}
                </div>
              </div>

              <DataTable1
                tableData={
                  [
                    {
                      type: {
                        headerValue: 'Type',
                        value: <SquareChip>MX</SquareChip>
                      },
                      host: {
                        headerValue: 'Host',
                        value: <div style={{ display: "flex", alignItems: "center" }}>
                          <TextInput error={this.state.failed.mx === true ? " " : ""} readOnly={true} value={"mpmail"} iconRight={<Icon name="copy" onClick={() => {
                            this.copyClipboard("mpmail")
                          }} />} />

                        </div>
                      },
                      value: {
                        headerValue: 'Value/Target',
                        value: <TextInput error={this.state.failed.mx === true ? " " : ""} readOnly={true} value={"mail.ourmailsender.com"} iconRight={<Icon name="copy" onClick={() => { this.copyClipboard("mail.ourmailsender.com") }} />} />
                      }
                    },
                    {
                      type: {
                        headerValue: 'Type',
                        value: <SquareChip>CNAME</SquareChip>
                      },
                      host: {
                        headerValue: 'Host',
                        value: <div style={{ display: "flex", alignItems: "center" }}>
                          <TextInput error={this.state.failed.dkim == true ? " " : ""} readOnly={true} value={"mp1._domainkey.mpmail"} iconRight={<Icon name="copy" onClick={() => { this.copyClipboard("mp1._domainkey.mpmail") }} />} />

                        </div>
                      },
                      value: {
                        headerValue: 'Value/Target',
                        value: <TextInput error={this.state.failed.dkim == true ? " " : ""} readOnly={true} value={"dkim.ourmailsender.com"} iconRight={<Icon name="copy" onClick={() => { this.copyClipboard("dkim.ourmailsender.com") }} />} />
                      }
                    },
                    {
                      type: {
                        headerValue: 'Type',
                        value: <SquareChip>TXT</SquareChip>
                      },
                      host: {
                        headerValue: 'Host',
                        value: <div style={{ display: "flex", alignItems: "center" }}>
                          <TextInput error={this.state.failed.spf == true ? " " : ""} readOnly={true} value={"mpmail"} iconRight={<Icon name="copy" onClick={() => { this.copyClipboard("mpmail") }} />} />

                        </div>
                      },
                      value: {
                        headerValue: 'Value/Target',
                        value: <TextInput error={this.state.failed.spf == true ? " " : ""} readOnly={true} value={`v=spf1 include:${spfHost} ~all`} iconRight={<Icon name="copy" onClick={() => { this.copyClipboard(`v=spf1 include:${spfHost} ~all`) }} />} />
                      }
                    }
                  ]}
                loadingData={[]}
                dataUpdater={() => { }}
                width='100%'
                pageSize='100'
                hasCheckBoxes='no'
                sortedColumn={""}
                sortedDirection={""}
                className='mar-b40'
              />

              {(this.state.hasChecked === 0) &&
                <div style={{ width: "100%" }}>
                  <Button
                    text={"Verify Records"}
                    iconRight={<Icons icon="arrowRight" color="#FFFFFF" />}
                    className="button-primary"
                    onClick={this.checkMxRecord}
                  />
                </div>
              }

              {(this.state.hasChecked === 1) &&
                <Paper style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div >
                    <LoadingIcons iconType="2" style={{ height: "24px", width: "24px", top: 0 }} />
                  </div>
                  <h4 className="mar-b5 mar-t15">We’re verifying your MX records</h4>
                  <div className="text-grey-800 text-sm">This should only take a moment...</div>
                </Paper>
              }


              {(this.state.hasChecked === 2) && (this.state.failed.mx || this.state.failed.dkim || this.state.failed.spf) &&
                <Paper style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                  <Icons icon="alertOutline" color="#E2AB1E" className="mar-b15" />

                  <h4 className="mar-b5">We couldn’t verify your MX records.</h4>
                  <div className="text-grey-800 text-sm mar-b15">Ensure the records you have added match the records above and try again.</div>

                  <Button
                    text={"Verify Records"}
                    iconRight={<Icons icon="arrowRight" color="#FFFFFF" />}
                    className="button-primary"
                    onClick={this.checkMxRecord}
                  />

                </Paper>
              }

              {(this.state.hasChecked === 2) && (!this.state.failed.mx && !this.state.failed.dkim && !this.state.failed.spf) &&
                <Paper style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                  <Icons icon="tickBreakingCircle" color="#319B90" className="mar-b15" />

                  <h4 className="mar-b5">Your MX records have been verified!</h4>
                  <div className="text-grey-800 text-sm mar-b15">Your emails will now be marked as originating from your domain.</div>

                  <Button
                    text={"Back to " + this.props.siteMaster.siteName}
                    iconRight={<Icons icon="arrowRight" color="#FFFFFF" />}
                    className="button-primary"
                    onClick={this.props.finish}
                  />

                </Paper>
              }
            </div>
          </div>
        </Modal >
        <SnackBar
          message={this.state.alertMessage}
          open={this.state.alertOpen}
          autoclose={true}
          dismiss={() => this.setState({ alertOpen: false })}
        />
      </>
    );
  }
}
